import { useCallback, useEffect, useState } from "react";
import Table from "../../common/Table";
import { useDispatch, useSelector } from "react-redux";
import { LuPencilLine } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { toast } from "react-toastify";
import ConfirmationPage from "../../common/ConfirmationPage";
import { deleteFaq, getFaqs } from "../../redux/services/faqSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant";

const FaqType = ["course", "workshop", "landing-page"];

const FAQ = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getFaqData = useSelector((state) => state?.faq?.faqData);
  const pathname = location?.pathname.split("/")[1]

  const route = {
    course: ROUTES.COURSES.FAQ_ADD_EDIT,
    workshop: ROUTES.WORKSHOPS.FAQ_ADD_EDIT,
    website: ROUTES.WEBSITE.FAQ_ADD_EDIT,
  }[pathname] || ROUTES.WEBSITE.FAQ_ADD_EDIT;

  const [page, setPage] = useState(0);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const [typeFilter, setTypeFilter] = useState(pathname)
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);

  const getAllFaqs = useCallback(async () => {
    try {
      await dispatch(
        getFaqs({ page: page + 1, limit: pageLimit, searchData, typeFilter })
      );
    } catch (error) { }
  }, [dispatch, page, pageLimit, searchData, typeFilter]);

  useEffect(() => {
    getAllFaqs();
  }, [getAllFaqs]);

  useEffect(() => {
    setTypeFilter(pathname)
  }, [pathname]);


  const deleteFaqData = async () => {
    try {
      const response = await dispatch(deleteFaq(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllFaqs();
    } catch (error) { }
  };

  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    { header: "Question", key: "question" },
    { header: "Answer", key: "answer" },
  ];

  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => {

        navigate(`${route}?faqId=${row._id}`, { state: { row } });
      },
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
  ];

  return (
    <>
      <Table
        title={`FAQ : ${pathname}`}
        buttonTitle="Add FAQ"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        onAddClick={() => navigate(route)}
        columns={columns}
        data={getFaqData?.faq_data || []}
        actions={actions}
        pageCount={getFaqData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
      />
      {confirm && (
        <ConfirmationPage
          topicName="FAQ"
          confirm={confirm}
          onDelete={deleteFaqData}
          onCancel={() => setConfirm(false)}
        />
      )}
    </>
  );
};

export default FAQ;


